import { SvgFile } from "../svg/Icons.ts";
import * as Html from "../util/Html.ts";
const MENU = new Map<string,(this:JQuery)=>ActionMenu>();

MENU.set('emojifood',function(){
  return {emoji:"🍽️ 🥣 ☕ 🍫 🍿 🍪 🍭 🍬 🍛 🍲 🥘 🫕 🌯 🥗 🍔 🌭 🍗 🥐 🍞 🥦 🥑 🍒 🍓 🍎 🍋 🥙 🍕 🍱 🍜 🥞 🍩 🍰 🍊 🥨 🥪 🦴".split(' ')}
})
MENU.set('emojibudget',function(){
  return {emoji:"🤷 💄 🍽️ 🚗 👕 🩺 📚 ⚡️ 🕹 🍿 🎁 🛒 💊 🏠 🛡 💵 🐶 🏦 💰 ⚽️ 📅 🚉 ✈️ 🏝 💸 🍔 🏧 🧸 ☎️ 📈 👔 💳 👥".split(' ')}
})
MENU.set('emojitext',function(){
  return {emoji:"😀 😂 😃 😄 😅 😆 😉 😊 😋 😌 😍 😏 😒 😓 😔 😖 😘 😚 😜 😝 😞 😠 😡 😢 😣 😤 😥 😨 😩 😪 😫 😭 😰 😱 😲 😳 😵 😷 😸 😹 😺 😻 😼 😽 😾 😿 🙀 🙅 🙆 🙇 🙈 🙉 🙊 🙋 🙌 🙍 🙎 🙏 😀 😇 😈 😎 😐 😑 😕 😗 😙 😛 😟 😦 😧 😬 😮 😯 😴 😶 ❤️ ✌ 🚼 ☕".split(' ')}
})
MENU.set('emojitimetable',function(){
  return {emoji:"⚽️ 🏀 🏈 ⚾️ 🥎 🎾 🏐 🏉 🏓 🎨 🎭 🎻 🍽️ 🎼 🎹 🏆 🏫 🎓 📖 🏥 🏨 🏠 🏖 🧼 🛍 🛒 🎉 🗓 📅 💼 🔁 ❤️ 🎟 ✈️ ⛵️ 💊".split(' ')}
})
MENU.set('emojilistcategory',function(){
  return {emoji:"🥬 🧀 🥑 🥥 🎒 👕 👗 👟 👠 🔨 💊 👓 🌳 🌿 🌸 🍭 🍵 🍷 👜 💼 📚 💍 💡 🧸 🎁 🧺 ✂️ 🖌 🪑 🏺 🎮 🖥 ⚽️ 🎨 🎧 🎭 🐶 🐱 🐹 🐰 🐠 🐓".split(' ')}
})
MENU.set('emojifiler',function(){
  return {emoji:"📁 📂 🗂 🏝 🏖 🎁 🏠 📊 🏥 🥘 🛠 🎓 🏫 📚 💰 📄 💼 🔐 🤫 🎥 📷 🌈 🖼 🎁 🛍 🛒 📋 🔍 ❤️ 🎵 🥳 🧠 🐶 🐱 ☀️ ⭐️".split(' ')}
})



Html.register({
  actionmenupick:function(value){
    this.parents(".selectable").prev().find('input').val(value).trigger('change')
  },
  togglemenu:function(){
    var 
      first = this.next('.sub'),
      items = [first]
    while(first = first.next('.sub')){
      if(first.length==0){
        break;
      }
      items.push(first)
    } 
    items.forEach(obj=>{
      if(obj.outerHeight()===0){
        obj.css('height',"44px")
      }else{
        obj.css('height',0)
      }
    })
    this.children().last().toggleClass('rotate180')
    return false;
  }
})
type ActionMenu = {
  menu ?: {svg ?:SvgFile,onclick?:string,i18nkey?:string,color?:string,opacity?:number}[],
  emoji ?: string[]
}
export function register(obj : {[key:string]:(this:JQuery)=>ActionMenu}){
  Object.entries(obj).forEach(([key,func])=>{
    if(MENU.has(key)){
      throw new Error("cannot define the same action twice : "+key);
    }else{
      MENU.set(key,func);
    }
  });
}
export async function getData(o :JQuery,key = o.attr('data-key')){
  var generator = MENU.get(key)
  return generator.call(o);
}